<template>
    <div id='dashboard'>
        <referral-for-interview v-if='!selectedBranch'></referral-for-interview>
<!-- 
        <b-button @click='getCovidStruct'>getStruct</b-button>

        <b-table v-if='struct' small striped hover :items='struct' ></b-table> -->

        <Uploader />

        <div  id='poll-table'>
            <section>
                <section id='poll-table-header' class='mx-3'>
                    <h4 class="pt-3">Список анкетированных <span v-if='selectedBranch'>[{{selectedBranch.Name_branch}}]</span></h4>
                    <span class='my-auto'>
                        <b-link class='mr-3' @click='clearBranch'>Сменить филиал</b-link>
                        <b-link class='mr-3' @click='goToQRForSelfrecord'>QR самозаписи</b-link>
                        <b-link class='mr-3' :href="interviewLink" target="_blank">Открыть новую анкету</b-link>
                        <b-link :href="interviewLinkForeign" target="_blank">Анкета иностранца</b-link>
                    </span>
                </section>
                <b-button-group class='search-buttons' size='sm'>
                    <b-button size='sm' @click='getCallingList' variant='success'><font-awesome-icon :icon="['fas', 'sync-alt']"/> Обновить</b-button>
                    <b-button size='sm' @click='globalSearch' variant='info'><font-awesome-icon :icon="['fas', 'search-location']"/> Искать везде</b-button>
                    <b-dropdown :text="`${selectedSort.text}`" size='sm' variant="primary">
                        <b-dropdown-item-button
                            v-for="sort in sortOptions"
                            :key="sort.value"
                            @click='setSortOption(sort)'
                        >
                            {{ sort.text }}
                        </b-dropdown-item-button>
                    </b-dropdown>
                </b-button-group>
                <b-input-group class="mx-3 mb-1 w-auto">
                    
                    <b-form-input
                        v-model="_searchByAllBranches"
                        @input='updateSearchByAllBranches'
                        type="search"
                        id="filterInput"
                        placeholder="Поиск..."
                    ></b-form-input>
                    <b-input-group-append>
                        <b-button :disabled="!_searchByAllBranches" @click="_searchByAllBranches = ''; updateSearchByAllBranches('')"><font-awesome-icon :icon="['fas', 'eraser']"/></b-button>
                    </b-input-group-append>
                </b-input-group>

                

                <b-table 
                    v-if='selectedBranch'
                    id='calling-list-table'
                    striped 
                    hover  
                    small
                    ref='patientsTable'
                    :stacked='isMobile' 
                    :current-page="_currentPage"
                    :per-page="0"
                    :busy.sync="callingListProcessing"
                    :filter="_searchByAllBranches"
                    :items="callingList"
                    :fields='callingListFields'
                    tbody-th-class="answer_type"
                >
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Загрузка...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(tel)='row'>
                        <b-link 
                            button
                            :href="`tel:${row.item.tel}`"
                            class='recall-btn py-0 text-center' 
                            variant='outline-success'
                            target="_blank"
                        >
                            {{row.item.tel}}
                        </b-link>
                    </template>

                     <template v-slot:cell(polis)='row'>
                        <span>
                            {{row.item.polis}}<br>
                            {{row.item.enfluence_org}}
                        </span>
                    </template>

                    <template v-slot:cell(io)='row'>
                        <section>
                            
                            <b-badge 
                                v-if='row.item.poll_data_approved > 0 && row.item.approved_by_admin === 0' 
                                pill 
                                variant='warning' 
                                v-b-tooltip.hover 
                                title="Готов к ручной проверке"
                                @click='approveThePoll(row.item.tk12121212)'
                            >
                                <font-awesome-icon class='mx-1' :icon="['fas', 'thumbs-up']"/>
                            </b-badge>
                            <b-badge 
                                v-if='row.item.poll_data_approved > 0 && row.item.approved_by_admin > 0'
                                pill 
                                variant='success' 
                                v-b-tooltip.hover 
                                title="Прошел ручную проверку"
                                @click='disapproveThePoll(row.item.tk12121212)'
                            >
                                <font-awesome-icon class='mx-1' :icon="['fas', 'thumbs-up']"/>
                            </b-badge>
                            <b-badge pill variant='info' v-if='row.item.nonresident > 0'  v-b-tooltip.hover title="Иногородний">
                                <font-awesome-icon class='mx-1' :icon="['fas', 'passport']"/>
                            </b-badge>
                            <b-badge pill variant='primary' v-if='row.item.foreigner > 0'  v-b-tooltip.hover title="Иностранец">
                                <font-awesome-icon class='mx-1' :icon="['fas', 'globe-americas']"/>
                            </b-badge>
                            {{row.item.io}}
                        </section>
                    </template>

                    <template v-slot:cell(comment)='row'>
                        <span>
                            Заполнено: {{row.item.ans_count}}<br>
                            <b-link 
                                button
                                :href="row.item.comment"
                                class='recall-btn py-0 text-center' 
                                variant='outline-success'
                                target="_blank"
                            >
                                Анкета <font-awesome-icon :icon="['fas', 'file-import']"/>
                            </b-link>
                            <b-button-group :class='isMobile ? "": "ml-2" '>
                                <b-button 
                                    v-if='row.item.id_patient > 0'
                                    @click='getDocumentPath(row.item.id_doc_poll)' 
                                    size='sm' 
                                    variant='outline-success'
                                    
                                >
                                    <p class='mb-0 d-flex justify-content-between'>
                                        Печать 
                                        <b-badge variant='success' pill>
                                            <font-awesome-icon :icon="['fas', 'print']"/>
                                            <span v-if='row.item.print_me > 0' v-b-tooltip.hover title="Распечатанно раз">{{row.item.print_me}}</span>
                                        </b-badge>
                                    </p>
                                </b-button>
                                <b-button 
                                    v-if='row.item.id_patient' 
                                    size='sm' 
                                    variant='outline-info'
                                    class='d-flex justify-content-between'
                                    @click='showUploaderModal(row.item)'
                                >
                                    Прикрепить <font-awesome-icon :icon="['fas', 'file-import']"/>
                                </b-button>
                            </b-button-group>
                        </span>
                    </template>

                    <template v-slot:cell(action)='row'>
                        <section class='d-flex action-buttons'>
                            <b-button 
                                v-if='row.item.id_patient === 0'
                                @click='pushToLine(row.item.comment)' 
                                size='sm' 
                                variant='outline-success'
                                class='w-75 mx-auto mb-1'
                            >
                                <font-awesome-icon :icon="['fas', 'id-badge']"/>
                            </b-button>
                            <b-button 
                                v-if='row.item.second_wave_button === 1'
                                @click='pushToLineSecondWave(row.item.comment)' 
                                size='sm' 
                                variant='outline-warning'
                                class=' mx-auto'
                            >
                                <font-awesome-icon :icon="['fas', 'id-badge']"/> <br>2 компонент
                            </b-button>
                        </section>
                    </template>
                    

                </b-table>
                <b-row class='mb-3 mx-1'>
                    <b-col>
                        <b-form-group
                            label="На страницу"
                            label-for="per-page-select"
                            label-cols="4"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            >
                            <b-form-select
                                id="per-page-select"
                                v-model="_perPage"
                                :options="pageOptions"
                                size="sm"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-pagination
                            pills
                            ref='patientsTablePagin'
                            v-model="_currentPage"
                            :total-rows="totalRows"
                            :per-page="_perPage"
                            align="fill"
                            size="sm"
                            class="my-auto w-50"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </section>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import CallComment from './../components/CallComment'
import Uploader from './../components/Uploader.vue'
import ReferralForInterview from './ReferralForInterview'
import { debounce } from "debounce";

export default {
    name: 'dashboard',
    components: { CallComment, ReferralForInterview, Uploader },
    data() {
        return {
            isMobile: false,
            pageOptions: [100, 200, 300],
            filter: null,
            // totalRows: 1,
            disableBtn: false,
            callingListFields: [
                { key: 'nomerok', label: '№', sortable: true },
                { key: 'io', label: 'Имя и отчество', sortable: true },
                { key: 'tel', label: 'Тел.', sortable: true },
                { key: 'date_call', label: 'Дата визита', sortable: true },
                { key: 'time_call', label: 'Время визита', sortable: true },
                { key: 'email', label: 'Email', sortable: true },
                { key: 'polis', label: 'Полис', sortable: true },
                { key: 'snils', label: 'СНИЛС', sortable: true },
                { key: 'comment', label: 'Анкета', thClass: 'interview-cell', tdClass: 'comment-cell' },
                { key: 'action', label: 'В очередь', thClass: 'line-cell', tdClass: 'action-cell' },
            ],
            sortOptions: [
                { text: 'По умолчанию', value: 0 },
                { text: 'По №. Первые', value: 1 },
                { text: 'По №. Послед.', value: -1 },
                { text: 'По ФИО', value: 2 },
                { text: 'По дате и времени', value: -3 },
                { text: 'Непроверенные', value: -4 },
            ]
        }
    },
    mounted() {
        
        this.isMobile = window.innerWidth <= 800;
    },
    methods: {
        dismissSocContractOpt(value) {
            if (value === 1) this.selectSocContract(0);
        },
        initRecall(id_call) {
            this.getRecall(id_call); 
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        pushToLine(qr) {
            let source = qr.substr(2);
            let query = source.split('/');
            this.crPatFromPoll(query[5]);
        },
        pushToLineSecondWave(qr) {
            let source = qr.substr(2);
            let query = source.split('/');
            this.secondWave(query[5]);
        },
        goToQRForSelfrecord() {
            let routeData = this.$router.resolve({name: 'qr-for-selfrecord', params: { id_login: this.userData.id_login }});
            console.log(routeData);
            window.open(routeData.href, '_blank');
        },
        showUploaderModal(item) {
            this.setDocType(null);
            this.selectPatient(item);
            this.getDocTypes()
            .then(() => this.$bvModal.show('uploader-modal'));
        },
        makeErrorToast() {
                this.$bvToast.toast(`Ошибка: ${this.errorText}`, {
                title: `Проверьте правильность заполнения анкеты`,
                variant: 'danger',
                solid: true
            })
        },
        makeSuccessToast() {
            this.$bvToast.toast('Вакцинируемый попал в очередь', {
                title: `Порядок!`,
                variant: 'success',
                solid: true
            })
        },
        getPageNum(val) {
            console.log(val)
        },
        ...mapActions('structs', ['getCovidStruct']),
        ...mapActions('covid', [
            'getNewTel', 'getCallingList', 'getCurrentCall', 
            'getAnswerTypes', 'selectMed',
            'selectORZ', 'selectSoc', 'selectAnswer',
            'saveCall', 'selectLec', 'selectSocContract',
            'selectPsych', 'getRecall', 'getVaccinCovidBranches',
            'getInterviewLink', 'clearBranch', 'crPatFromPoll',
            'getDocuments', 'getDocumentPath', 'clearCallingList',
            'secondWave', 'updateSearchByAllBranches', 'globalSearch',
            'updatePerPageValue', 'updateCurrentpage', 'getPollsApproved',
            'getDocTypes', 'selectPatient', 'setDocType', 'approveThePoll',
            'setSortOption', 'disapproveThePoll'
        ])
    },
    computed: {
        ...mapState({
            struct: state => state.structs.struct,
            firstVictimCheck: state => state.firstVictimCheck,
            callingList: state => state.covid.callingList,
            covidOptions: state => state.covid.covidOptions,
            vaccinCovidBranches: state => state.covid.vaccinCovidBranches,
            interviewLink: state => state.covid.interviewLink,
            interviewLinkForeign: state => state.covid.interviewLinkForeign,
            selectedBranch: state => state.covid.selectedBranch,
            resError: state => state.covid.resError,
            errorText: state => state.covid.errorText,
            callingListProcessing: state => state.covid.callingListProcessing,
            searchByAllBranches: state => state.covid.searchByAllBranches,
            perPage: state => state.covid.perPage,
            currentPage: state => state.covid.currentPage,
            userData: state => state.userData,
            selectedSort: state => state.covid.sortOption
        }),
        totalRows() { 
            if (this.selectedBranch) return this.selectedBranch.pat_cnt 
        },

        _searchByAllBranches: {
            get() { return this.searchByAllBranches },
            set: debounce(function(value) {
                this.updateSearchByAllBranches(value)
                if (this.$refs.patientsTable.filteredItems.length === 0) this.globalSearch()
            }, 500)
        },

        _currentPage: {
            get() { return this.currentPage },
            set(value) { 
                this.updateCurrentpage(value);
                this.$refs.patientsTable.refresh();
            }
        },
        _perPage: {
            get() { return this.perPage },
            set(value) { this.updatePerPageValue(value) }
        }
    },
    watch: {
        resError(error) {
            if (error === null) return;
            if (error > 0) {
                this.makeErrorToast();
            } else {
                this.makeSuccessToast()
            }
        },
        selectedBranch(branch) {
            if (!branch) {
                this.clearCallingList()
            }
        }
        
    }
}
</script>

<style>
#poll-table-header {
    display: flex;
    justify-content: space-between;
}

#dashboard {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
.answer {
    min-width: 300px !important;
}
.struct-table {
    flex: 1 0 auto;
}
#wrapper {
    min-height: 50vh;
}
#calling-list-table {
    flex: 0 1 auto;
}
.action-buttons {
    display: flex;
    flex-direction: column;
}
.recall-btn {
    width: 80px;
}
.phone-icon {
    font-size: 1.5rem;
}
.search-buttons {
    display: flex;
    width: fit-content;
    margin-left: 1rem;
    margin-bottom: 0.5rem;
}
.faq-script {
    font-size: 0.8rem;
    /* max-height: 200px; */
    /* overflow-y: auto; */
}
.phone {
    margin-left: 2rem;
}
.short-list {
    display: none;
}
.interview-cell {
    min-width: 210px;
}
.line-cell{ 
    min-width: 90px;
}
.action-cell {
    min-width: 150px;
}
.comment-cell {
    min-width: 300px;
}
@media (max-width: 536px) {
    .finish-call {
        margin-top: 1rem;
    }
    .faq-script {
        margin-top: 1rem;
    }
    .pat-name {
        font-size: 1.2rem;
    }
    .phone {
        margin-left: 0;
    }

    .short-list {
        display: block;
    }
    .recall-btn {
        width: 60px;
    }
    #poll-table-header {
        flex-direction: column;
        margin-bottom: 1rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard.vue